import React from 'react';
import './Testimonials.css'
import testimonialOne from '../../../assets/Students/testimonialOne.png'
import testimonialTwo from '../../../assets/Students/testimonialTwo.png'
import testimonialThree from '../../../assets/Students/testimonialThree.png'
import testimonialFour from '../../../assets/Students/testimonialFour.png'
import testimonialFive from '../../../assets/Students/testimonialFive.png'
import testimonialSix from '../../../assets/Students/testimonialSix.png'

function Testimonials() {
  const testimonials = [
    {
      name: 'Ashish Chettri',
      text: 'The teachers here were so supportive and friendly. They truly understand the challenges students from the hills face and guide us with patience.',
      image: testimonialTwo
    },
    {
      name: 'Nikhil Roka',
      text: 'The training I received here made me job-ready from day one. Im thankful to LIMS.',
      image: testimonialOne
    },
    {
      name: 'Asif Karki',
      text: `I have been a student of LIMS and not only I got the knowledge about Hotel Industry but after passing out also they have guided me on every step towards my goal of joining the Cruise. `,
      image: testimonialSix
    },
    {
      name: 'Namgay Dema Dukpa',
      text: `I'm presently working with Carnival Cruise Line & I'm so much blessed to be working in one of the best Cruise Lines. Thank you LIMS.`,
      image: testimonialFour
    },
    {
      name: 'Nimasang Yolmo',
      text: `They helped me a lot in building my career as well as my personality too. Thank you to my Instructors and Directors for your guidance.`,
      image: testimonialThree
    },
    {
      name: 'Rachna Chettri',
      text: `Choosing my career in Hotel Management was the best decision I made and I studied in Lalit's Institute of Management Studies. I gained knowledge about F&B Service and worked in Hotels and later joined Cruise Line.`,
      image: testimonialFive
    },
  ];
  return (
    <div className='testimonials-outer'>
      <h2 className="header-text header-testimony">What Our Students Say</h2>
      <div className="testimonials-inner">
        {/* Here goes cards which will behave like a card stacking overflow */}
        {testimonials.map((testimony, index) => (
          <div className="testimonials-card d-flex justify-content-center align-items-center" key={index} >
            <div className="testimonial-image">
              <img src={testimony.image} alt={testimony.name} />
            </div>
            <div className="testimonial-section d-flex justify-content-center align-items-start flex-column">
              <h4 className="testimonial-name">{testimony.name}</h4>
              <p className="testimonial letter-text">{testimony.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Testimonials
